import React, { useEffect, useState, useCallback } from "react";
import PreviousIcon from "../../../../components/Common/SvgIcons/CommonIcons/PreviousIcon";
import classes from "./ForumComments.module.scss";
import profileImg from "../../../../assets/images/Common/profileImg.svg";
import Button from "../../../../components/Common/Button/Button";
import { useSelector, useDispatch } from "react-redux";
import InfiniteScrollComponent from "../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import {
  createForumCommentActionHandler,
  getForumCommentsActionHandler,
  updateDorumCommentActionHandler,
} from "../../../../store/actions/actionHandlers/socialActionHandler";
import Loader from "../../../../components/Common/Loader/Loader";
import ToggleButton from "../../../../components/Common/ToggleButton/ToggleButton";
import { FormattedMessage } from "react-intl";

const ForumComments = ({
  forumComments,
  setForumComments,
  selectedThread,
  forumCommentsTotalRows,
  setForumCommentsPageNum,
  forumCommentsPageNum,
  pageSize,
  setForumCommentsTotalRows,
  setSelectedThread,
  forumCommentLoader,
}) => {
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile, colors } = commonState;
  const socialState = useSelector((state) => state.socialReducer);
  const { createForumCommentLoader } = socialState;
  const [hasMoreData, setHasMoreData] = useState(true);
  const [comment, setComment] = useState("");
  const [createForumCommentResponseData, setCreateForumCommentResponseData] =
    useState(null);
  const [loader, setLoader] = useState(false);

  const fetchMoreData = useCallback(() => {
    if (forumComments?.length >= forumCommentsTotalRows) {
      setHasMoreData(false);
      return;
    }
    setForumCommentsPageNum((prevState) => prevState + 1);
  }, [forumComments, forumCommentsTotalRows, setForumCommentsPageNum]);

  useEffect(() => {
    if (forumCommentsPageNum > 1 && !createForumCommentResponseData)
      dispatch(
        getForumCommentsActionHandler(
          selectedThread?.Id,
          forumCommentsPageNum,
          pageSize,
          setForumComments,
          setForumCommentsTotalRows,
          setLoader
        )
      );
    if (createForumCommentResponseData) {
      setHasMoreData(true);
      dispatch(
        getForumCommentsActionHandler(
          selectedThread?.Id,
          forumCommentsPageNum,
          pageSize,
          setForumComments,
          setForumCommentsTotalRows,
          setLoader
        )
      );
    }
  }, [
    dispatch,
    pageSize,
    forumCommentsPageNum,
    selectedThread,
    setForumComments,
    setForumCommentsTotalRows,
    createForumCommentResponseData,
    setForumCommentsPageNum,
  ]);

  useEffect(() => {
    if (forumComments?.length === 0) setHasMoreData(false);
  }, [forumComments]);

  const handleChange = (e) => {
    setComment(e.target.value);
  };

  const handleSubmit = () => {
    if (comment.trim()) {
      setCreateForumCommentResponseData(null);
      const obj = {
        Comment: comment?.trim(),
        ThreadId: selectedThread?.Id,
      };
      setComment("");
      dispatch(
        createForumCommentActionHandler(
          obj,
          setCreateForumCommentResponseData,
          setForumCommentsPageNum,
          selectedThread?.Id,
          1,
          pageSize,
          setForumComments,
          setForumCommentsTotalRows
        )
      );
    }
  };

  const handleCommentToggleClick = (isEnable, id) => {
    const obj = {
      Id: id,
      IsEnabled: isEnable ? false : true,
    };
    dispatch(updateDorumCommentActionHandler(obj)).then((res) => {
      if (res.status === 200 && res.data) {
        const updatedComments = forumComments?.map((comment) => {
          if (id === comment?.Id) {
            return { ...comment, IsEnabled: isEnable ? false : true };
          } else return comment;
        });
        setForumComments(updatedComments);
      }
    });
  };
  return (
    <div className={classes.forumComments}>
      <div className={classes.heading}>
        <div className={classes.backBtn}>
          <PreviousIcon fill={colors.theme} />
          <div
            className={classes.backTxt}
            onClick={() => {
              setForumComments(null);
              setForumCommentsPageNum(1);
              setSelectedThread(null);
            }}
          >
            <FormattedMessage id="BACK" />
          </div>
        </div>
        <div className={classes.details}>
          <div className={classes.text}>
            {" "}
            <FormattedMessage id="CREATED_BY" /> : {selectedThread?.CreatedBy}
          </div>
          <div className={classes.text}>{selectedThread?.CreatedOn}</div>
        </div>
      </div>

      <div className={classes.content}>
        <div className={classes.title}>
          {/* {selectedThread?.ThreadName?.length > 130
            ? selectedThread?.ThreadName?.slice(0, 130) + "..."
            : selectedThread?.ThreadName} */}
          {selectedThread?.ThreadName}
        </div>

        <div className={classes.chat_history}>
          <div className={classes.chat_window}>
            {forumComments?.length > 0 && (
              <InfiniteScrollComponent
                dataLength={forumComments?.length ? forumComments.length : 10}
                fetchMoreData={fetchMoreData}
                hasMoreData={hasMoreData}
                // height={"72vh"}
              >
                {forumComments?.map((comment, index) => {
                  return (
                    <div
                      className={
                        comment?.CreatedBy ===
                        myProfile?.FirstName + " " + myProfile?.LastName
                          ? classes.current_user_chat_item +
                            " " +
                            classes.chat_item
                          : classes.chat_item
                      }
                      key={comment?.Id}
                    >
                      {comment?.CreatedBy !==
                        myProfile?.FirstName + " " + myProfile?.LastName && (
                        <div className={classes.description_meta_info}>
                          <div className={classes.avtar}>
                            <img
                              src={
                                comment?.CommentedByPhotoUrl
                                  ? comment?.CommentedByPhotoUrl
                                  : profileImg
                              }
                              className={classes.avtar_image}
                              alt="PROFILE_IMAGE"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = profileImg;
                              }}
                            />
                          </div>
                          <div className={classes.avtar_name}>
                            {comment?.CreatedBy}
                          </div>
                        </div>
                      )}
                      <div className={classes.chat_time}>
                        <div>
                          <span>
                            {new Date(comment?.CreatedOn).toLocaleDateString(
                              "en-GB"
                            )}
                          </span>{" "}
                          <span>
                            {new Date(comment?.CreatedOn).toLocaleTimeString(
                              "en-US",
                              {
                                hour: "numeric",
                                minute: "numeric",
                              }
                            )}
                          </span>
                        </div>
                        <ToggleButton
                          type="small"
                          enable={comment?.IsEnabled}
                          handleClick={() =>
                            handleCommentToggleClick(
                              comment?.IsEnabled,
                              comment?.Id
                            )
                          }
                        />
                      </div>
                      <div
                        className={
                          comment?.CreatedBy ===
                          myProfile?.FirstName + " " + myProfile?.LastName
                            ? classes.current_user_chat_content
                            : classes.chat_content
                        }
                      >
                        {comment?.Comment}
                      </div>
                    </div>
                  );
                })}
              </InfiniteScrollComponent>
            )}
            {forumComments?.length === 0 && (
              <div className={classes.loader}>No Records Found</div>
            )}
            {forumCommentLoader && (
              <div className={classes.loader}>
                <Loader height="5%" width="5%" />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={classes.chat_footer}>
        <div className={classes.message_type_field}>
          <div className={classes.text_box}>
            <input
              className={classes.text_input}
              placeholder="Type your comment here"
              rows="1"
              value={comment}
              onChange={handleChange}
              onKeyDown={(event) => {
                if (event.key === "Enter") handleSubmit();
              }}
              maxLength="500"
            />
          </div>
          <div className={classes.message_action}>
            <Button
              type="submit"
              label={<FormattedMessage id="FORUM_SUBMIT" />}
              dark
              borderRadius="5"
              width="11.2"
              height="4.2"
              disabled={!comment.trim()}
              onClick={handleSubmit}
              backgroundColor={createForumCommentLoader ? undefined : "#D31B61"}
              loading={createForumCommentLoader}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForumComments;
